import {Component, OnInit, Input, OnDestroy, OnChanges, SimpleChanges, Output, EventEmitter} from '@angular/core';
import * as _ from 'lodash';
import { DragulaService } from 'ng2-dragula';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { ValidatorUtils } from '../../../shared/utils/src/validator.utils';
import { StringUtils} from '../../../shared/utils/src/string.utils';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
@Component({
    selector: 'delay-rule-component',
    templateUrl: './delay-rule.component.html'
})

export class DelayRuleComponent implements OnInit, OnDestroy, OnChanges, OnDestroy {
    @Input() timeTypeSelectConfigForDelayTime: any;
    @Input() public ruleInfo = [];
    @Input() public isEditable: boolean;
    @Output() public routeNotUse: EventEmitter<any> = new EventEmitter();

    isInvalid = false;
    isEmptyDelayTime: boolean;
    isEmptyAlertCount: boolean;

    ruleIndex = 0;

    public isNullDelayCnd = false;
    public isNullDelayTime = false;

    // private subscription: Subscription;
    private langSubscription: Subscription;

    isAllChecked: boolean;

    msg_MK00843 = '';
    MsgSpecFlag = false;
    MsgSpec = '';

    alertCountMax = '5';
    delayTimeMax = '9999';

    constructor(private dragulaService: DragulaService,
                private translateService: TranslateService) {

        this.msg_MK00843 = this.translateService.instant('MK.00843');
        dragulaService.drop.subscribe((value: any) => {
            if (value[0] === 'delayRule') {
                this.resetOrdrNo();
            }
        });

        dragulaService.setOptions('delayRule', {
            moves: function (el, container, handle) {
                return handle.className === 'dragable_button dragable_flag';
            }
        });


        // this.subscription = Observable.fromEvent(document, 'click')
        //     .subscribe( (event: Event) => this.clickHandler(event) );
    }

    ngOnInit() {
        this.langSubscription = this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
            this.msg_MK00843 = this.translateService.instant('MK.00843');
        });
    }


    ngOnChanges(changes: SimpleChanges) {
        this.isNullDelayCnd = false;
        this.isNullDelayTime = false;

        const isEditableChange = changes['isEditable'];

        if (isEditableChange && this.isEditable) {
            if (this.ruleInfo.length === 0) {
                this.ruleSetAdd();
            }
        }
    }

    ngOnDestroy() {
        this.dragulaService.destroy('delayRule');
        // this.subscription.unsubscribe();
        this.langSubscription.unsubscribe();
    }

    public ruleSetAdd() {
        this.ruleIndex++;
        this.ruleInfo.push({
            'ordrNo': this.ruleIndex,
            'delayTime': '',
            'alertCount': ''
        });
    }


    public ruleSetRemove(event, ordrNo) {
        _.remove(this.ruleInfo, {ordrNo : ordrNo});

        this.resetOrdrNo();
    }

    public resetOrdrNo() {
        this.ruleIndex = 0;

        this.ruleInfo.forEach((ruleSet, index) => {
            index++;
            ruleSet.ordrNo = index;
            this.ruleIndex = index;
        });

        if (this.ruleIndex === 0) {
            this.routeNotUse.emit('delay');
        }
    }

    public getRuleInfo(): any {
        const _delayRuleInfo = [];
        $('#delayRule tbody tr').each(function (_index) {
            let delayTime = $(this).find('#delayTime').val();

            /*let alertCountFlag = 'N';
            if ($(this).find('input:checkbox[name="alertCountFlag"]').first().is(':checked')) {
                alertCountFlag = 'Y';
            }*/

            const timeType = $(this).find('#timeType').val();
            if (timeType === 'min') {
                delayTime = delayTime * 60;
            } else if (timeType === 'hour') {
                delayTime = delayTime * 60 * 60;
            }

            const alertCount = $(this).find('#alertCount').val();

            const cndVal = `${delayTime}::${alertCount}`;

            const delayRule = {
                ordrNo: _index + 1,                                         //룰셋팅 순번
                cndCnnTypeCd: _index === 0 ? 'RUCDCN10' : 'RUCDCN20', //첫번째룰은 if 두번째룰은 else if
                msgSpecFildNo: '0',
                oprTypeCd: 'COPR010',                                    // 서프레션룰은  isequal로 판단하여 처리함. $(this).find('#oprTypeList option:selected').val(),
                cndVal: cndVal,                 //"120::4"   시간:사용여부:4
                cndValAryYn: 'Y',
                cndValSprtnChaVal: '::',
                routTrgtNo: '10014'             //테스트를 위하여 임의로 10001     등록함
            };
            _delayRuleInfo.push(delayRule);
        });

        return _delayRuleInfo;
    }

    public validation() {
        let  delayTime = '';
        let  alertCount = '';
        $('#delayRule tbody tr').each(function (i) {
            delayTime = $(this).find('#delayTime').val();
            alertCount = $(this).find('#alertCount').val();
        });
        let delayValidation = true;

        this.isEmptyDelayTime = false;
        this.isEmptyAlertCount = false;

        if (StringUtils.isEmpty(delayTime.trim())) {
            this.isEmptyDelayTime = true;
        }

        if (StringUtils.isEmpty(alertCount.trim())) {
            this.isEmptyAlertCount = true;
        }

        if( this.isEmptyDelayTime || this.isEmptyAlertCount ) {
            delayValidation = false;
        }

        return delayValidation;
    }

    onlyNumber(event) {
        return ValidatorUtils.onlyNumber(event);
    }

    removeChar(event) {
        this.validValue(event);
        ValidatorUtils.removeChar(event);
        this.setDelayTimeMinMaxByTimeType(event);
    }

    checkMinMax(event) {
        this.setDelayTimeMinMaxByTimeType(event);
    }

    validValue(event) {
        if (event.code.indexOf('Digit') > -1) {
            if (event.target.id === 'delayTime') {
                this.isEmptyDelayTime = false;
            } else if (event.target.id === 'alertCount') {
                this.isEmptyAlertCount = false;
            }

        }
    }

    setDelayTimeMinMaxByTimeType(event) {
        if (event.target.id === 'timeType') {
            const delayTime = $('#delayRule tbody tr').find('#delayTime').val();
            const timeType = event.target.value;
            this.setMaxDelayTime(timeType);
            const max = Number(this.delayTimeMax);
            this.ruleInfo[0].delayTime = this.validDelayTime(delayTime, 1, max);
        } else if (event.target.id === 'delayTime') {
            const timeType = $('#delayRule tbody tr').find('#timeType').val();
            this.setMaxDelayTime(timeType);
            ValidatorUtils.checkNumberValidation(event);
        } else if (event.target.id === 'alertCount') {
            ValidatorUtils.checkNumberValidation(event);
        }
    }

    validDelayTime(delayTime, min, max) {
        if (delayTime === null || delayTime === undefined || delayTime.trim() === '') {
            delayTime = min;
        }

        delayTime = Number(delayTime.replace(/[^0-9]/g, ''));

        if (delayTime < min) {
            delayTime = min;
        }
        if (delayTime > max ) {
            delayTime = max;
        }
        return delayTime;
    }

    setMaxDelayTime(timeType) {
        if (timeType === 'sec') {
            this.delayTimeMax = '3600';
        } else if (timeType === 'min') {
            this.delayTimeMax = '60';
        } else if (timeType === 'hour') {
            this.delayTimeMax = '1';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/ruleSet/delay-rule/delay-rule.component.ts